import { TableDataProperties } from '../../../shared/uiComponents/Table/tableProperties';
import { SessionTypeProperties, UserBriefInfoProperties } from './calendarProperties';
import { InsuranceAuthorizationTypeProperties } from './insuranceAuthorizationProperties';
import { LocationTypes } from './soapNoteProperties';

export interface GetReportProperties {
	clientId?: string;
	createdById?: string;
	credentialed?: boolean;
	direction: string;
	endDate: string;
	includeAdditionalData?: boolean;
	onlyNew: boolean;
	onlySubmitted?: boolean;
	orderBy: string;
	page: string;
	pageSize: string;
	searchString: string;
	startDate: string;
	userId: string;
}

export interface GetBillingProperties extends GetReportProperties {
	clientIds: string[];
	mbhBillingStatus?: string;
}

export interface GetTotalBillingProperties {
	clientIds: string[];
	endDate: string;

	startDate: string;
	userId?: string;
}

interface BillingClientProperties {
	dateOfBirthday: string;
	email: string;
	firstName: string;
	fullName: string;
	gender: string;

	id: string;
	lastName: string;
}

interface AuthorizedUserInfoProperties extends UserBriefInfoProperties {
	authorizationType: InsuranceAuthorizationTypeProperties | null;
}

export interface ModifiedSessionProperties {
	dateModifiedAt: string;
	dateModifiedBy: {
		authorizationType: InsuranceAuthorizationTypeProperties;
		fullName: string;
		id: string;
		role: string;
	};
	originalDate: string;
	originalEndTime: string;
	originalStartTime: string;
}

export enum MBHBillingStatus {
	'Not Billed',
	'Approved',
	'Billed',
}

export interface BillingProperties {
	authorizedBCBA: null | AuthorizedUserInfoProperties;
	billedBy: null | AuthorizedUserInfoProperties;
	client: BillingClientProperties;
	location: LocationTypes | null;
	mainTherapist: null | AuthorizedUserInfoProperties;
	mbhBillingStatus: MBHBillingStatus | null;
	reportExportedAt: string | null;
	reportExportedBy: AuthorizedUserInfoProperties | null;
	reportId: string;
	reportSubmittedAt: string;
	sessionDate: string;
	sessionDateModifiedDetails: ModifiedSessionProperties | null;
	sessionEndTime: string;
	sessionId: string;
	sessionStartTime: string;
	sessionType: SessionTypeProperties;
	user: AuthorizedUserInfoProperties;
}

export interface BillingSessionsProperties extends TableDataProperties {
	query: BillingProperties[] | null;
}

export interface MBHLogsProperties {
	createdAt: string;

	id: string;
	syncStatus: boolean;
	syncedSessionCount: number;
}
